import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type LoaderState = {
  isLoading: {
    status: boolean
    from: string
    message: string
  }
}

type LoaderActions = {
  setIsLoading: (status: boolean, from: string, message: string) => void
}

export const useLoaderStore = create<LoaderState & LoaderActions>()(
  devtools(
    (set) => ({
      isLoading: {
        status: false,
        from: '',
        message: '',
      },
      setIsLoading: (status, from, message) =>
        set({ isLoading: { status, from, message } }),
    }),
    { name: 'loader-store' }
  )
)
